module.exports = __webpack_public_path__ + "img/4_dice[4].1a69446d.png";